import locale from '../th-TH.json';

const settingsTargets = [
  window.reactSettings,
  window.reactSettingsExhibitorHubHomepage,
  window.reactSettingsExhibitorHubHeader,
];

settingsTargets.forEach((settings) => {
  if (!settings?.props) return;
  settings.props.localisation = settings.props.localisation || {};
  settings.props.localisation['th-TH'] = locale;
});
